import { atom } from 'jotai'

import type { SettingTab } from '@/lib/configs/setting-config'

/**
 * Opens the Settings dialog from anywhere in the dashboard (e.g. a toast's action button),
 * without routing to the /settings page. `null` = closed. Read by GlobalSettingsDialog,
 * mounted once in ExchangeTabGroupProvider.
 */
export type SettingsDialogRequest = {
  tab: SettingTab
  /** Spotlight Settings → Accounts' "Add account" button on open. */
  highlightAddAccount?: boolean
  /** Scroll to and highlight this account in the Accounts tab. */
  highlightAccountId?: string
  /** Also open this account's Manage access panel (members + invite by email). */
  manageAccessAccountId?: string
}

export const settingsDialogRequestAtom = atom<SettingsDialogRequest | null>(null)
